export const EXACT = 'exact';
export const ALTERNATIVE = 'alternative';
export const WIDE = 'wide';
export const VERY_WIDE = 'very-wide';

const LABELS = {
	[EXACT]: 'Passend',
	[ALTERNATIVE]: 'Sehr ähnlich',
	[WIDE]: 'Ähnlich',
	[VERY_WIDE]: 'Weitere',
};

export function getAll ()
{
	return [
		EXACT,
		ALTERNATIVE,
		WIDE,
		VERY_WIDE
	];
}

export function getLabel (id)
{
	return LABELS[id];
}
